export const SuggestionService = Symbol('SuggestionService');

export interface SuggestionService {
    changeActiveSuggestionIdx: (activeSuggestionIdx: number) => void;
}
